import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, ProgressBar } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function TeamProfile({ title, data, variant }) {
  const teamProfile = useMemo(() => (
    data && Object.keys(data).map(
      (name) => {
        const { before, after } = data[name];

        return (
          <div key={name}>
            <h6 className="mt-3">{name}</h6>

            <Row className="align-items-center small">
              <Col xs="10" className="pe-0">
                <ProgressBar now={before} className={`thin-bar ${variant}-bar before-bar`} />
              </Col>

              <Col xs="2" className="small">
                <small>
                  {before}
                  %
                </small>
              </Col>
            </Row>

            <Row className="align-items-center small">
              <Col xs="10" className="pe-0">
                <ProgressBar now={after} className={`thin-bar ${variant}-bar`} />
              </Col>

              <Col xs="2" className="small">
                <small>
                  {after}
                  %
                </small>
              </Col>
            </Row>
          </div>
        );
      },
    )
  ), [data]);

  return (
    <div className="h-100 border border-2 rounded-3 p-3">
      <Row className="mb-4 align-items-center">
        <Col xs="8">
          <h5>{title}</h5>
        </Col>

        <Col xs="4" className="small">
          <Row className="align-items-center small">
            <Col xs="4" className="pe-0">
              <ProgressBar now="100" className={`thin-bar ${variant}-bar before-bar`} />
            </Col>

            <Col xs="8">
              <small>Before</small>
            </Col>
          </Row>

          <Row className="align-items-center small">
            <Col xs="4" className="pe-0">
              <ProgressBar now="100" className={`thin-bar ${variant}-bar`} />
            </Col>

            <Col xs="8">
              <small>After</small>
            </Col>
          </Row>
        </Col>
      </Row>

      {!data ? <LoadingPlaceholder className="mb-3" /> : teamProfile}
    </div>
  );
}

TeamProfile.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  variant: PropTypes.string.isRequired,
};

TeamProfile.defaultProps = {
  title: 'Team Profile',
  data: null,
};
